import { Component } from '@angular/core';
import { HandsetService } from '../../../core/services/handset.service';
import { ActivatedRoute } from '@angular/router';
import { ToolbarService } from '../../../core/services/toolbar.service';
import { CustomerBiller } from '../../../billers/models/model';
import { AddManualLiabilityData } from '../../models/add-manual-liability-data.model';

@Component({
standalone: false,
  selector: 'app-add-liability-manual-container',
  templateUrl: './add-liability-manual-container.component.html',
  styleUrls: ['./add-liability-manual-container.component.scss'],
})
export class AddLiabilityManualContainerComponent {
  title = 'Wprowadź dane';
  subtitle = 'Uzupełnij poniższe dane aby dodać wydatek.';
  initialValue: AddManualLiabilityData | undefined;
  customerBiller: CustomerBiller;

  constructor(
    public handsetService: HandsetService,
    private route: ActivatedRoute,
    private toolbar: ToolbarService,
    private activatedRoute: ActivatedRoute) {
    this.toolbar.init(this.route);
    this.activatedRoute.data.subscribe((data: { customerBiller: CustomerBiller }) => {
      if (data.customerBiller) {
        this.customerBiller = data.customerBiller;
        this.initialValue = {
          customerId: null,
          billerId: this.customerBiller.biller.code,
          biller: this.customerBiller.biller.name,
          nip: this.customerBiller.biller.nip,
          bban: this.customerBiller.manualConfiguration.bban,
          title: this.customerBiller.manualConfiguration.title,
          amount: this.customerBiller.manualConfiguration.amount,
          amountToPay: this.customerBiller.manualConfiguration.amount,
          paymentDue: this.customerBiller.manualConfiguration.firstPaymentDate,
        };
      }
    });
  }
}
